






















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { mapKeys, upperFirst } from 'lodash';

import ObjectMapper, { ObjectModel } from '@/components/object_mapper/ObjectMapper.vue';
import { keysToSnake } from '@/utils';

export default Vue.extend({
  name: 'AswStep3MapperWrapper',
  components: {
    ObjectMapper,
  },
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  data() {
    const startingFilters = <any>{
      object: null,
      type: null,
    };
    const extraRequestData = {
      fkFilters: JSON.stringify([
        {
          field: 'audit_id',
          id: this.audit.id,
        },
      ]),
    };

    return {
      rightColumnType: {},
      leftColumnType: {},
      startingFilters: [startingFilters],
      extraRequestData: keysToSnake(extraRequestData),
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      apiEndpoints: 'objectMapperApiEndpoints',
      rawAvailableMapTypes: 'availableMapTypes',
      modelMeta: 'modelMeta',
    }),
    ...mapGetters('auditSetupWizard', ['isManagedInExternalSystem']),
    availableMapTypes(): any {
      const types = mapKeys(this.rawAvailableMapTypes, (_, key) => upperFirst(key));
      // Allow just Controls to be mapped
      types['Control'] = [this.getModel('request')];
      return types;
    },
  },
  created() {
    const requestObject = this.isManagedInExternalSystem ? 'externalRequest' : 'request';
    this.rightColumnType = this.getModel(requestObject);
    this.leftColumnType = this.getModel('control');
  },
  methods: {
    getModel(type: string): ObjectModel {
      return {
        model: this.modelMeta[type].modelSingular,
        plural: this.modelMeta[type].modelPlural,
        singular: this.modelMeta[type].modelSingular,
      };
    },
  },
});
